import {
	FormControl,
	FormLabel,
	Heading,
	Input,
	PhoneInput,
	Stack,
	ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useUserContext } from "../../hooks/use-user-context";
import { PostLoginOnboardingStepsProps } from "./post-login-onboarding";
import { useEffect, useState } from "react";
import { isNullOrWhiteSpace, normalizePhoneNumber } from "../../utils/string-helper";
import { useTranslation } from "react-i18next";
import { LoginInfoSchema } from "../../models/user";
import { useUpdateUserQuery } from "../../hooks/use-update-user-query";
import { useLocalePhoneInput } from "../../hooks/use-locale-phone-input";

export const PostLoginOnboardningContactInfo = ({ setContinueButton }: PostLoginOnboardingStepsProps) => {
	const { user } = useUserContext();
	const { t } = useTranslation();
	const { saveUserAsync } = useUpdateUserQuery(LoginInfoSchema.pick({ email: true, mobilePhone: true }));

	const normalizedMobilePhone = normalizePhoneNumber(user?.mobilePhone);
	const phone = useLocalePhoneInput({
		isRequired: false,
		defaultValue: normalizedMobilePhone,
	});
	const [email, setEmail] = useState(user?.email ?? "");
	const [emailValid, setEmailValid] = useState(true);

	const isEmpty = isNullOrWhiteSpace(user?.mobilePhone) && isNullOrWhiteSpace(user?.email);

	const onEmailBlur = (value: string) => {
		const result = LoginInfoSchema.pick({ email: true }).safeParse({ email: value });
		setEmailValid(result.success);
	};

	useEffect(() => {
		const save = async () => {
			const haveChanges = phone.e164 !== normalizedMobilePhone || email !== user?.email;
			return haveChanges ? await saveUserAsync({ mobilePhone: phone.e164, email }) : true;
		};

		setContinueButton({
			isDisabled:
				!LoginInfoSchema.pick({ email: true }).safeParse({ email: email }).success || !phone.isValid,
			save: save,
		});
	}, [email, normalizedMobilePhone, phone.e164, phone.isValid, saveUserAsync, setContinueButton, user]);

	return (
		<Stack gap={ThemeSpaceVariable.Large}>
			<Heading as="h1">
				{isEmpty
					? t("post_login_onboarding_contact_info_title_empty")
					: t("post_login_onboarding_contact_info_title")}
			</Heading>
			<Stack gap={ThemeSpaceVariable.Medium}>
				<FormControl {...phone.formControlProps}>
					<FormLabel>{t("profile_mobilePhone")}</FormLabel>
					<PhoneInput {...phone.inputProps} size={"lg"} />
				</FormControl>
				<FormControl isInvalid={!emailValid}>
					<FormLabel>{t("profile_email")}</FormLabel>
					<Input
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						onBlur={(e) => onEmailBlur(e.target.value)}
						type="email"
						placeholder="namn@mail.com"
						size={"lg"}
					/>
				</FormControl>
			</Stack>
		</Stack>
	);
};
